export default __webpack_public_path__ + "static/media/Intermedium.5ca7ca72.woff2";